(function() {

  'use strict';

  function ModalLiberacaoColetaController($scope, $uibModalInstance, Historico) {

    $scope.showFormReleasePickUp = true;
    $scope.loadingStateModalPickUp = false;
    $scope.showContactSuccess = false;
    $scope.showContactUsForm = false;

    $scope.ok = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.tryAgain = function() {
      $scope.securityCode = null;
      $scope.loadingStateModalPickUp = false;
      $scope.showFormReleasePickUp = true;
      $scope.showReleasePickUpError = false;
    }

    $scope.backToPickUpError = function() {
      $scope.customerPhone = null;
      $scope.loadingStateModalPickUp = false;
      $scope.showContactUsForm = false;
      $scope.showReleasePickUpError = true;
    }

    $scope.contactUs = function() {
      $scope.loadingStateModalPickUp = false;
      $scope.showFormReleasePickUp = false;
      $scope.showReleasePickUpError = false;
      $scope.showContactUsForm = true;
    }

    $scope.pickUpWarn = function(form) {
      $scope.loadingStateModalPickUp = true;
      $scope.showContactUsForm = false;

      $scope.phone = customerPhone.value.replace(/[{()}]/g, '');
      $scope.phone = $scope.phone.replace(/-/g, '');
      $scope.ddd = $scope.phone.substr(0,2);
      $scope.numero = $scope.phone.substr(3, ($scope.phone.length - 3));
      Historico.pickUpWarn({
          "ddd": $scope.ddd,
          "numero": $scope.numero
        })
      .then(function(data){
        $scope.loadingStateModalPickUp = false;
        $scope.showContactSuccess = true;
      })
      .catch(function(err){})
    };

    // Verifica o código de segurança
    $scope.checkSecurityCode = function(form) {
      $scope.loadingStateModalPickUp = true;

      if(!form.$valid) {
        $scope.loadingStateModalPickUp = false;
        return
      };

      Historico.releasePickUp(securityCode.value)
        .then(function(data){
          $scope.loadingStateModalPickUp = false;
          $scope.showFormReleasePickUp = false;
          $scope.showDriverCard = true;
          $scope.driverData = data;

          if($scope.driverData.urlImagem === null) {
            $scope.driverData.urlImagem = "/assets/images/default-profile-picture.png";;
          }

        })
        .catch(function(err){
          $scope.loadingStateModalPickUp = false;
          $scope.showFormReleasePickUp = false;
          $scope.showReleasePickUpError = true;
        });
    }

  };
  angular
    .module('mandaeApp')
    .controller('ModalLiberacaoColetaController', ModalLiberacaoColetaController);
})();
